export const SLOW_WORD_CALL_THRESHOLD_MS = 15_000;

type WordCallTrackerListener = () => void;

export class WordCallTracker {
    private readonly startedAtMsByCallId = new Map<number, number>();
    private readonly listeners = new Set<WordCallTrackerListener>();
    private nextCallId = 0;

    constructor(private readonly nowMs: () => number = () => Date.now()) {}

    beginCall(): () => void {
        const callId = this.nextCallId;
        this.nextCallId += 1;
        this.startedAtMsByCallId.set(callId, this.nowMs());
        this.notifyListeners();
        return () => {
            if (!this.startedAtMsByCallId.delete(callId)) return;
            this.notifyListeners();
        };
    }

    inFlightCallCount(): number {
        return this.startedAtMsByCallId.size;
    }

    oldestInFlightCallAgeMs(): number | null {
        if (this.startedAtMsByCallId.size === 0) return null;
        const oldestStartedAtMs = Math.min(...this.startedAtMsByCallId.values());
        return this.nowMs() - oldestStartedAtMs;
    }

    isWordRespondingSlowly(): boolean {
        const oldestAgeMs = this.oldestInFlightCallAgeMs();
        return oldestAgeMs !== null && oldestAgeMs > SLOW_WORD_CALL_THRESHOLD_MS;
    }

    subscribe(listener: WordCallTrackerListener): () => void {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }

    private notifyListeners(): void {
        this.listeners.forEach((listener) => listener());
    }
}

export const wordCallTracker = new WordCallTracker();
